let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kf2cy")).then(() => parcelRequire('fnQQ1'));